var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.76 12.1365C17.76 11.711 17.7218 11.3019 17.6509 10.9092H12V13.2301H15.2291C15.09 13.9801 14.6673 14.6155 14.0318 15.041V16.5465H15.9709C17.1055 15.5019 17.76 13.9637 17.76 12.1365Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.9999C13.62 17.9999 14.9782 17.4626 15.9709 16.5463L14.0318 15.0408C13.4945 15.4008 12.8073 15.6135 12 15.6135C10.4373 15.6135 9.11455 14.5581 8.64273 13.1399H6.63818V14.6944C7.62546 16.6553 9.65455 17.9999 12 17.9999Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64273 13.14C8.52273 12.78 8.45455 12.3954 8.45455 12C8.45455 11.6045 8.52273 11.22 8.64273 10.86V9.30542H6.63818C6.23182 10.1154 6 11.0318 6 12C6 12.9681 6.23182 13.8845 6.63818 14.6945L8.64273 13.14Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.38636C12.8809 8.38636 13.6718 8.68909 14.2936 9.28364L16.0145 7.56273C14.9755 6.59455 13.6173 6 12 6C9.65455 6 7.62546 7.34455 6.63818 9.30545L8.64273 10.86C9.11455 9.44182 10.4373 8.38636 12 8.38636Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f8cc7c54bc74d6420b9728f57cca0e76.svg";
export { ForwardRef as ReactComponent };